var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 488,
    height: 312,
    viewBox: "0 0 488 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Feature-3-svg-a",
    x: 132,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -144, -10)",
    filter: "url(#Feature-3-svg-a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(144 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 89,
    rx: 6,
    transform: "translate(157.5 104) rotate(90)",
    fill: "#de4b35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 89,
    rx: 6,
    transform: "translate(113 168) rotate(90)",
    fill: "#de4b35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 66,
    rx: 6,
    transform: "translate(90 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 57,
    rx: 6,
    transform: "translate(176.5 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 49,
    rx: 6,
    transform: "translate(128 200) rotate(90)",
    fill: "#de4b35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 35,
    rx: 6,
    transform: "translate(58 137) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 35,
    rx: 6,
    transform: "translate(175.5 137) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 153,
    rx: 6,
    transform: "translate(175.5 137) rotate(90)",
    fill: "#de4b35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(35 18)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.851,
    y: 17
  }, "Procurement"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.208,
    y: 35
  }, "Agreement"))), /*#__PURE__*/React.createElement("path", {
    d: "M99,32.5,0,.5",
    transform: "translate(295 124.5)",
    fill: "none",
    stroke: "#4135af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(384 194)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.172,
    y: 17
  }, "Counterparty")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 194)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38.826,
    y: 17
  }, "You")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 112)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333 2.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.618,61.334H5.714A5.739,5.739,0,0,1,0,55.584V50.6A16.068,16.068,0,0,1,16,34.5H37.334a16.067,16.067,0,0,1,16,16.1v4.985A5.739,5.739,0,0,1,47.618,61.334ZM26.666,30.667A15.334,15.334,0,1,1,41.9,15.334,15.3,15.3,0,0,1,26.666,30.667Z",
    fill: "#794bb4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(404 112)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333 2.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.618,61.334H5.714A5.739,5.739,0,0,1,0,55.584V50.6A16.068,16.068,0,0,1,16,34.5H37.334a16.067,16.067,0,0,1,16,16.1v4.985A5.739,5.739,0,0,1,47.618,61.334ZM26.666,30.667A15.334,15.334,0,1,1,41.9,15.334,15.3,15.3,0,0,1,26.666,30.667Z",
    fill: "#de4b35"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.3354a643289fba7f4301f3b0496bb866.svg";
export { ForwardRef as ReactComponent };